import PageBar from "../../components/dashboard/page-bar/PageBar";
import ListResume from "../../components/list-resume/positionList/ListResume";

function ListResumePage({ advanceData, dataForm, onChangeVal, setDataShowCom, setFormData, emailSendModal, setSelectedIds, selectedIds }) {
  return (
    <div className="pageWrapper">
      <PageBar title="List Resume" />
      <ListResume advanceData={advanceData} dataForm={dataForm} onChangeVal={onChangeVal} setDataShowCom={setDataShowCom} setFormData={setFormData} emailSendModal={emailSendModal} setSelectedIds={setSelectedIds} selectedIds={selectedIds} />
    </div>
  );
}

export default ListResumePage;
